import styled from "@emotion/styled";
import Skeleton, { type SkeletonProps } from "@mui/material/Skeleton";

type Props = SkeletonProps;

const StyledSkeleton = styled(Skeleton)`
  background-color: ${(props) => props.theme.palette.secondary.main}33;
  border-radius: ${(props) => props.theme.borderRadius};
`;

export const BlSkeleton = (props: Props): React.ReactNode => {
  return <StyledSkeleton {...props} />;
};
